import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { X, Loader2, Ban } from "lucide-react";
import { toast } from "sonner";
import { orderNo } from "@/lib/order";

const QUICK = ["Item out of stock", "Kitchen closing", "Duplicate order", "Customer request"];

export const CancelOrderDialog = ({ order, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put(`/my/orders/${order.id}/cancel`, { reason });
      toast.success(`Order #${orderNo(order)} cancelled`);
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <form data-testid="cancel-order-dialog" onSubmit={submit} className="bg-slate-900 border border-slate-800 rounded-2xl w-full max-w-sm p-6 space-y-4 fade-up" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-xl font-bold">Cancel order #{orderNo(order)}</h3>
          <button type="button" data-testid="close-cancel-dialog" onClick={onClose} className="text-slate-400 hover:text-white"><X className="h-5 w-5" /></button>
        </div>
        <p className="text-sm text-slate-400">Table {order.table_number}. The diner will see this reason on their tracking screen.</p>
        <div className="flex flex-wrap gap-2">
          {QUICK.map((q) => (
            <button type="button" key={q} data-testid={`cancel-quick-${q.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setReason(q)} className={`text-xs rounded-full px-3 py-1.5 border transition-colors ${reason === q ? "border-red-500 text-red-300 bg-red-950/40" : "border-slate-700 text-slate-300 hover:border-slate-500"}`}>
              {q}
            </button>
          ))}
        </div>
        <input data-testid="cancel-reason-input" required maxLength={200} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Short reason for the diner" className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-red-500" />
        <button data-testid="confirm-cancel-order" type="submit" disabled={busy || !reason.trim()} className="w-full inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 disabled:opacity-60 rounded-xl py-3 font-semibold transition-colors">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Ban className="h-4 w-4" />} Cancel order
        </button>
      </form>
    </div>
  );
};
